const { process_question_event } = require("../forms/process_question_event");
export const listQuestions = (list, container) => {
  if (!Array.isArray(list) || list.length === 0) {
    console.warn("No questions to render");
    return;
  }
  console.log(list);
  let showContainer = document.getElementById(container);
  showContainer.innerHTML = "";
  let abody = list
    .map((question) => {
      let faculty = question.faculty,
        answerStatus,
        dataName,
        margin,
        markText,
        publishStatus,
        pushText,
        showFaculty,
        user = question.user,
        userName;

      if (faculty.length == 1) {
        margin = `margin: 0 10px 0 0;`;
      } else {
        margin = `margin: 12px 10px 0 0;`;
      }
      if (faculty.length !== 0) {
        showFaculty = `<span class="header-text">${faculty}</span>`;
      } else {
        showFaculty = `No Speaker was Selected`;
      }

      if (user.length != 0) {
        if (
          user.firstName != null ||
          user.lastName != null ||
          user.degree != null
        ) {
          if (user.degree.length != 0 || user.degree != null) {
            userName = `${user.firstName} ${user.lastName}, ${user.degree}`;
          } else {
            userName = `${user.firstName} ${user.lastName}`;
          }
        } else {
          userName = "User not Included";
        }
      } else {
        userName = `User not included`;
      }
      pushText = "";

      if (question.push_question == 1) {
        pushText = `Unpublish`;
        publishStatus = 0;
      } else {
        pushText = `Publish`;
        publishStatus = 1;
      }
      if (question.answered == 1) {
        dataName = `markNotAnswered`;
        answerStatus = 0;
        markText = `Mark as Not Answered`;
      } else {
        dataName = `markAnswered`;
        answerStatus = 1;
        markText = `Mark as Answered`;
      }
      return `<div class="card" key="${question.question_id}">
      <div class="card-header">
        <div style=" float: left; ${margin}">
          <span class="badge badge-info" style="font-size: 16px">For</span>
        </div>
        <div style="float: left">${showFaculty}</div>                                        
      </div>
      <div class="card-body">                                                
        <div class="col px-0" id="questionArea">
          <span>${question.question}</span>
          <br><span class="qFrom">From: ${userName}</span>
          <br><button class="btn btn-primary btn-sm" name="questionEvent" id="questionMark${question.question_id}" data-name="${dataName}" data-id="${question.question_id}" data-status="${answerStatus}">${markText}</button>
          <button class="btn btn-info btn-sm" name="questionEvent" id="questionPush${question.question_id}" data-name="pushQuestion" data-id="${question.question_id}" data-status="${publishStatus}">${pushText}</button>
        </div>
      </div>                                        
    </div>`;
    })
    .join("");

  showContainer.innerHTML += abody;

  let questionEvent = document.querySelectorAll("button[name='questionEvent']");
  questionEvent.forEach((button) => {
    button.addEventListener("click", process_question_event);
  });
};
